import styled from "styled-components";
import media from "constants/media";
import { skeleton } from "components/shared/skeleton/Skeleton";

export const SkeletonStyled = styled.div`
    ${() => skeleton()}

    height: 340px;

    ${media.mdUp`
        height: 125px;
        margin-bottom: 10px;
    `}
`;
